(() => {
  'use strict';
  const $ = s => document.querySelector(`.kks-b-scope ${s}`);
  const $$ = s => [...document.querySelectorAll(`.kks-b-scope ${s}`)];
  function initHeader() {
    const menu=$('#menu-toggle'), nav=$('#mobile-nav'), theme=$('#theme-toggle');
    if (!menu || menu.dataset.bound) return;
    menu.dataset.bound='true';
    menu.addEventListener('click',()=>{
      const open=menu.getAttribute('aria-expanded')!=='true';
      menu.setAttribute('aria-expanded',String(open)); nav.hidden=!open;
    });
    window.addEventListener('keydown',e=>{
      if(e.key==='Escape'&&!nav.hidden){nav.hidden=true;menu.setAttribute('aria-expanded','false');menu.focus();}
    });
    theme.addEventListener('click',()=>{
      const dark=document.body.dataset.theme!=='dark';
      document.body.dataset.theme=dark?'dark':'light';
      theme.setAttribute('aria-label',dark?theme.dataset.lightLabel:theme.dataset.darkLabel);
    });
  }
  let observer;
  function initProduct() {
    const form=$('#product-form');
    if(!form||form.dataset.kksBound)return;
    form.dataset.kksBound='true';
    const variants=JSON.parse($('#kks-b-variants').textContent);
    const labels=$('[data-product-labels]').dataset;
    const qty=$('#quantity'), add=$('#add-button'), sticky=$('#sticky-add');
    const input=$('#variant-id');
    const gallery=$$('[data-image]').map(b=>({src:b.dataset.src,alt:b.dataset.alt,caption:b.dataset.caption,show:b.dataset.showCaption==='true'}));
    let imageIndex=0, pending=false;
    const quantity=()=>{const n=Number(qty.value);return Number.isInteger(n)&&n>=1&&n<=99?n:null;};
    function updateQuantity(){
      const n=quantity();
      $('#quantity-minus').disabled=!n||n<=1;$('#quantity-plus').disabled=!n||n>=99;
      $('#sticky-quantity').textContent=n>1?` · ${labels.qty} ${n}`:'';
    }
    $('#quantity-minus').addEventListener('click',()=>{qty.value=Math.max(1,(quantity()||1)-1);updateQuantity();});
    $('#quantity-plus').addEventListener('click',()=>{qty.value=Math.min(99,(quantity()||1)+1);updateQuantity();});
    qty.addEventListener('input',updateQuantity);
    qty.addEventListener('change',()=>{if(!quantity())qty.value=1;updateQuantity();});
    function showImage(index){
      if(!gallery.length)return;
      imageIndex=(index+gallery.length)%gallery.length;
      const g=gallery[imageIndex], main=$('#main-image');
      main.src=g.src;main.alt=g.alt;
      $('#image-number').textContent=String(imageIndex+1).padStart(2,'0');
      $('#image-caption').textContent=g.caption;
      $('#image-caption').classList.toggle('show-caption',g.show);
      $$('[data-image]').forEach((b,i)=>{b.classList.toggle('selected',i===imageIndex);b.setAttribute('aria-pressed',String(i===imageIndex));});
    }
    $$('[data-image]').forEach(b=>b.addEventListener('click',()=>showImage(Number(b.dataset.image))));
    let touchX=0,touchY=0;
    $('.gallery-stage').addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;touchY=e.changedTouches[0].clientY;},{passive:true});
    $('.gallery-stage').addEventListener('touchend',e=>{
      const dx=e.changedTouches[0].clientX-touchX,dy=e.changedTouches[0].clientY-touchY;
      if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)showImage(imageIndex+(dx<0?1:-1));
    },{passive:true});
    const dialog=$('#image-dialog');
    $('#enlarge-image').addEventListener('click',()=>{
      $('#dialog-image').src=$('#main-image').src;$('#dialog-image').alt=$('#main-image').alt;dialog.showModal();
    });
    $('#close-image').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    function selectVariant(id,changeURL=true){
      const v=variants.find(x=>String(x.id)===String(id));if(!v)return;
      input.value=v.id;
      $('#price').innerHTML=v.money;$('#sticky-price').innerHTML=v.money;
      $('#selected-size').textContent=v.title;$('#sticky-size').textContent=v.title;
      add.disabled=!v.available;sticky.disabled=!v.available;
      add.querySelector('span:first-child').textContent=v.available?labels.add:labels.sold;
      sticky.firstChild.textContent=(v.available?labels.add:labels.sold)+' ';
      $('#stock-status').textContent=v.available?labels.available:labels.unavailable;
      $('#stock-status').classList.toggle('available',v.available);
      $$('input[name=size]').forEach(r=>{r.checked=r.value===String(v.id);});
      if(v.image&&$('#main-image').src!==v.image){$('#main-image').src=v.image;$('#main-image').alt=$('#product-title').textContent;}
      if(changeURL){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);}
      // Preserve the existing theme's pubsub variant notifications for apps.
      document.dispatchEvent(new CustomEvent('kks:variant-change',{detail:{variant:v,form}}));
    }
    $$('input[name=size]').forEach(r=>r.addEventListener('change',()=>selectVariant(r.value)));
    input.addEventListener('change',()=>selectVariant(input.value));
    // Native Sleek ProductForm owns AJAX, bundled cart sections, error handling
    // and the cart drawer. These listeners only guard/synchronize the UI.
    form.addEventListener('submit',e=>{
      if(pending||!quantity()||add.disabled){e.preventDefault();e.stopImmediatePropagation();return;}
      pending=true;sticky.setAttribute('aria-disabled','true');
      const release=()=>{pending=false;sticky.removeAttribute('aria-disabled');};
      const mutation=new MutationObserver(()=>{if(!add.hasAttribute('aria-disabled')){release();mutation.disconnect();}});
      mutation.observe(add,{attributes:true,attributeFilter:['aria-disabled']});
      window.setTimeout(()=>{release();mutation.disconnect();},15000);
    },true);
    observer?.disconnect();
    observer=new IntersectionObserver(entries=>{
      const e=entries[0],show=!e.isIntersecting&&e.boundingClientRect.bottom<0;
      $('#sticky-purchase').hidden=!show;document.body.classList.toggle('sticky-visible',show);
    });observer.observe(add);
    selectVariant(input.dataset.initialVariant||input.value,false);updateQuantity();showImage(0);
    // Enhance only after successful initialization. Until then the native
    // selector is the sole enabled size control and owns Shopify's name=id.
    $$('input[name=size]').forEach(r=>{
      r.disabled=!variants.find(v=>String(v.id)===r.value)?.available;
    });
    $('#size-options').hidden=false;
    $('#selected-size').hidden=false;
    input.hidden=true;
    $('#quantity-minus').hidden=false;
    $('#quantity-plus').hidden=false;
    form.dataset.kksReady='true';
  }
  function anchors(){
    const target=document.getElementById(location.hash.slice(1));
    if(target?.tagName==='DETAILS')target.open=true;
  }
  document.addEventListener('click',e=>{
    const a=e.target.closest('.kks-b-scope a[href^="#"]');if(!a)return;
    const target=document.getElementById(a.hash.slice(1));if(target?.tagName==='DETAILS')target.open=true;
  });
  window.addEventListener('hashchange',anchors);
  function init(){initHeader();initProduct();anchors();}
  document.addEventListener('shopify:section:load',init);
  init();
})();
